import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { SearchService } from '../../../common/services/search.service';
import { SiteService  } from '../../../common/services/site.service';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppSettings } from '../../../common/constants/appSettings.constants';
import { APIDomain, APIDomainVersion } from '../../../common/models/site.model';

@Component({
    selector: 'app-search-filters',
    templateUrl: './search-filters.component.html',
    styleUrl: './search-filters.component.scss',
    standalone: false
})
export class SearchFiltersComponent implements OnInit{
  private destroyRef = inject(DestroyRef);
  isHidden = false;
  settings = AppSettings;
  currentDomainVersion: APIDomainVersion = this.settings.general.defaultDomainVersion;
  coreVersions: string[] = [];
  allyVersions: string[] = [];

  constructor(
    private searchService: SearchService,
    private siteService: SiteService,
  ) {}

  apiGroupFilter: Array<any> = [];
  groupFiltersWithCount: Array<any> = [];
  apiResultTypes: Array<any> = [];
  typeFiltersWithCount: Array<any> = [];

  get activeDomain(): APIDomain {
    return this.currentDomainVersion.startsWith('ally_') ? 'ally' : 'core';
  }

  get activeVersion(): string {
    return this.currentDomainVersion.split('_')[1] ?? '';
  }

  get versionsForActiveDomain(): string[] {
    return this.activeDomain === 'ally' ? this.allyVersions : this.coreVersions;
  }

  ngOnInit(): void {
    this.siteService.currentDomainVersion$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((domainVersion: APIDomainVersion) => {
      this.currentDomainVersion = domainVersion;
    });

    this.siteService.coreVersions$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(versions => {
      this.coreVersions = versions;
    });

    this.siteService.allyVersions$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(versions => {
      this.allyVersions = versions;
    });

    this.searchService.groupFiltersWithCount$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((filters) => {
      this.groupFiltersWithCount = filters;
    });

    this.searchService.typeFiltersWithCount$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((filters) => {
      this.typeFiltersWithCount = filters;
    });
  }


  onDomainFilterClick(domain: APIDomain): void {
    if (this.activeDomain === domain) return;
    this.searchService.setSearching(true);
    this.siteService.changeDomain(domain);
    this.searchService.refreshResults();
  }

  onVersionFilterClick(version: string): void {
    if (this.activeVersion === version) return;
    this.searchService.setSearching(true);
    this.siteService.changeVersion(version);
    this.searchService.refreshResults();
  }

  onSidebarToggle() {
    this.isHidden = !this.isHidden;
  }

  onFilterCheck(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    let isChecked = (event.target as HTMLInputElement).checked;
    this.searchService.setSearching(true);
    this.searchService.setSelectedGroupFilter(value, isChecked);

    let parentNode = ( <HTMLElement>( <HTMLElement>event.target ).parentNode );
    if (parentNode.classList.contains("active")) {
      parentNode.classList.remove("active");
    } else {
      parentNode.classList.add("active");
    }
  }

  onTypeFilterCheck(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.searchService.setSearching(true);
    let isChecked = (event.target as HTMLInputElement).checked;
    this.searchService.setSelectedTypeFilter( value, isChecked );
    let parentNode = ( <HTMLElement>( <HTMLElement>event.target ).parentNode );
    if (parentNode.classList.contains("active")) {
      parentNode.classList.remove("active");
    } else {
      parentNode.classList.add("active");
    }
  }

}
